import type { PlanSummary } from '@developerz/domain';
import { A } from '@solidjs/router';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { focusPlan } from '../lib/custom-plans';
import { orgHref } from '../lib/org';

// The "Custom plans" section's not-in-list notice. One not-found case this
// covers: a deep link `?plan=<id>` whose id is not on the CURRENT page (the
// response's rows), with no cross-page lookup. Resolves the verdict through
// `focusPlan` over the rows actually rendered, then points the reader at the
// full-view route so they can land there directly. The link is org-scoped
// through `orgHref` (same pattern `PlanBreakdown.tsx`/`PlanCard.tsx` use) — a
// bare `/fleet/plans/<id>` falls through the legacy redirect into the
// session's DEFAULT org, not the org the reader is currently viewing, which
// 404s the plan for anyone on a second org.

export function CustomPlansNotInListNotice(props: {
  readonly rows: readonly PlanSummary[];
  readonly planParam: () => string | null;
}): JSX.Element {
  return (
    <Show
      when={(() => {
        const verdict = focusPlan(props.rows, props.planParam());
        return verdict.kind === 'not_in_list' ? verdict : null;
      })()}
    >
      {(verdict) => (
        <div class="alert" role="note">
          <p class="alert__desc">
            {t('fleet.plans.custom.not_in_list')}{' '}
            <A href={orgHref(`/fleet/plans/${encodeURIComponent(verdict().planId)}`)}>
              {t('fleet.plans.custom.open_full')}
            </A>
          </p>
        </div>
      )}
    </Show>
  );
}
